import { createContext, FC, ReactNode, useContext } from 'react';
import { appStore, IAppStore } from 'store';
import { useStore } from 'zustand';

interface IProvider {
  children: ReactNode;
}

const StoreStateContext = createContext<IAppStore | undefined>(undefined);

export const StoreStateProvider: FC<IProvider> = ({ children }) => {
  const value = useStore(appStore);

  return (
    <StoreStateContext.Provider value={value}>
      {children}
    </StoreStateContext.Provider>
  );
};

export const useStoreState = () => {
  const context = useContext(StoreStateContext);
  if (!context) {
    throw new Error('useStoreState must be used within an StoreStateProvider');
  }
  return context;
};
